import { capitalize, each } from 'lodash'
import { INIT_CURRENT_RUBRIC } from '../types/rubric'

const state = {
  currentRubric: null
}

const getters = {
  currentRubric: state => state.currentRubric
}

const actions = {
  /**
   * Pull current rubric from API
   *
   * @param ctx
   */
  [INIT_CURRENT_RUBRIC](ctx) {
    let rootGetters = ctx.rootGetters

    return ctx.rootState.api
      .getCurrentRubric({
        options: rootGetters.authOptions
      })
      .then(function(rubric) {
        let dependencies = {}
        each(rubric.metrics, function(metric, key) {
          metric.key = key
          if (!metric.title) {
            metric.title = capitalize(key)
          }
          if (metric.function) {
            metric.fn = metric.function
            /*
            // dependencies is already defined in src/api/rubric/current.json.
            try {
              metric.dependencies = filter(metric.fn.split(/avg\(|min\(|[\W+\-,]+/g), o => o.length)
            } catch (e) {
              // pass
            }
            */
          }
          if (metric.dependencies) {
            each(metric.dependencies, function(dep) {
              if (dep in dependencies) {
                dependencies[dep].push(key)
              } else {
                dependencies[dep] = [key]
              }
            })
          }
          each(metric.metricBands, function(band) {
            band.midValue = parseFloat(band.midValue)
            band.minValue = parseFloat(band.minValue)
            band.maxValue = parseFloat(band.maxValue)
          })
        })
        rubric.dependencies = dependencies
        ctx.commit(INIT_CURRENT_RUBRIC, {
          rubric
        })
        console.log(INIT_CURRENT_RUBRIC, rubric)
        return rubric
      })
  }
}

const mutations = {
  [INIT_CURRENT_RUBRIC](state, change) {
    state.currentRubric = change.rubric
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
